import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { NumericFormat } from "react-number-format";

const Capnhatxedien = React.memo(function Capnhatxedien(props) {
  const { thang } = props;
  const [thangnam, setThangnam] = React.useState(dayjs());
  const [soluongxe, setSoluongxe] = React.useState(0);
  const [sonhanvienlaixe, setSonhanvienlaixe] = React.useState(0);
  const [sotuyenhoatdong, setSotuyenhoatdong] = React.useState(0);
  const [thoigianhoatdong, setThoigianhoatdong] = React.useState("");
  const [sochuyenthuchien, setSochuyenthuchien] = React.useState(0);
  const [sochuyenkehoach, setSochuyenkehoach] = React.useState(0);
  const [sokhachvanchuyen, setSokhachvanchuyen] = React.useState(0);
  const [sokhachluanchuyen, setSokhachluanchuyen] = React.useState(0);
  const [doanhthu, setDoanhthu] = React.useState(0);
  const [giacuoc, setGiacuoc] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getthongtin = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getslthxedienthang?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setSoluongxe(data[0].soluongxe);
        setSonhanvienlaixe(data[0].sonhanvienlaixe);
        setSotuyenhoatdong(data[0].sotuyenhoatdong);
        setThoigianhoatdong(data[0].thoigianhoatdong);
        setSochuyenthuchien(data[0].sochuyenthuchien);
        setSochuyenkehoach(data[0].sochuyenkehoach);
        setSokhachvanchuyen(data[0].sokhachvanchuyen);
        setSokhachluanchuyen(data[0].sokhachluanchuyen);
        setDoanhthu(data[0].doanhthu);
        setGiacuoc(data[0].giacuoc);
        let [month, year] = data[0].thang.split("/");
        setThangnam(dayjs(year + "-" + month));
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhatbaocao = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url = Config.backend + "/api/Phuongtien/themslthxediendvthang";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        thang: thang,
        soluongxe: soluongxe,
        sonhanvienlaixe: sonhanvienlaixe,
        sotuyenhoatdong: sotuyenhoatdong,
        thoigianhoatdong: thoigianhoatdong,
        giacuoc: giacuoc,
        sochuyenthuchien: sochuyenthuchien,
        sochuyenkehoach: sochuyenkehoach,
        sokhachvanchuyen: sokhachvanchuyen,
        sokhachluanchuyen: sokhachluanchuyen,
        doanhthu: doanhthu,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
        } else showNotification1();
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  React.useEffect(() => {
    getthongtin();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Tháng báo cáo"
                  value={thangnam}
                  format="MM/YYYY"
                  onChange={(newValue) => setThangnam(newValue)}
                  slotProps={{ textField: { size: "small" } }}
                  views={["month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <NumericFormat
                label="Số lượng xe"
                variant="outlined"
                size="small"
                value={soluongxe}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSoluongxe(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <NumericFormat
                label="Số nhân viên lái xe"
                variant="outlined"
                size="small"
                value={sonhanvienlaixe}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSonhanvienlaixe(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <NumericFormat
                label="Số tuyến đường hoạt động"
                variant="outlined"
                size="small"
                value={sotuyenhoatdong}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSotuyenhoatdong(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <TextField
                label="Thời gian hoạt động"
                variant="outlined"
                size="small"
                value={thoigianhoatdong}
                onChange={(event) => {
                  setThoigianhoatdong(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <TextField
                label="Giá cước"
                variant="outlined"
                size="small"
                value={giacuoc}
                onChange={(event) => {
                  setGiacuoc(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <NumericFormat
                label="Số chuyến thực hiện"
                variant="outlined"
                size="small"
                value={sochuyenthuchien}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyenthuchien(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <NumericFormat
                label="Số chuyến kế hoạch"
                variant="outlined"
                size="small"
                value={sochuyenkehoach}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyenkehoach(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <NumericFormat
                label="Số khách vận chuyển"
                variant="outlined"
                size="small"
                value={sokhachvanchuyen}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSokhachvanchuyen(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <NumericFormat
                label="Số khách luân chuyển"
                variant="outlined"
                size="small"
                value={sokhachluanchuyen}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSokhachluanchuyen(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "6px" }}>
              <TextField
                label="Doanh thu (tr.đ)"
                variant="outlined"
                size="small"
                value={doanhthu}
                onChange={(event) => {
                  setDoanhthu(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "30px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhatbaocao}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatxedien.propTypes = {
  thang: PropTypes.string,
};
export default Capnhatxedien;
